import { TextInput } from "../../../../../shared/react/TextInput";
import { GenericProps } from "../types";

interface Props extends GenericProps {
}

export function UsersFilter({ state, dispatch }: Props) {

    const set = (users: string) => {
        dispatch({ type: "updateFilters", payload: { users } })
    }

    return <TextInput
        value={state.filters.users}
        setValue={set}
        placeholder="Filter by user name"
    />
}